import { StepLoadingIcon } from '@/assets/icons/step-loading-icon'

interface FinalStepLoadingProps {
  loadingLabel: string
}

export const FinalStepLoading = ({ loadingLabel }: FinalStepLoadingProps) => {
  return (
    <div className="flex justify-center items-center flex-col gap-3">
      <StepLoadingIcon />
      <div className="flex gap-1 text-[var(--brand-blue-3)] font-bold text-2xl">
        <p>{loadingLabel}</p>
      </div>
    </div>
  )
}
